import React from 'react'
import ErrorMsgCallout from '../../molecules/ErrorMsgCallout'

// It is a Thunk/High order function!
export default () => () =>
  (
    <ErrorMsgCallout
      text="Este e-mail já possui cadastro."
      linkText="Esqueceu sua senha?"
      href="/recuperacao-senha"
    />
  )
